export default "/kiban/_next/static/images/boardThickness-614bcff1e1ac31c8aba3a650846114ee.png";